<script src="../store/index.js"></script>
<template>
    <div class="mainBox">
        <LeftNav />
        <div class="rightContainer">
            <router-view></router-view>
        </div>
        <div style="clear:both"></div>
    </div>
</template>

<script>
import LeftNav from "@/components/leftNav";
export default {
  name: 'Home',
  components: {
    LeftNav
  },
    data () {
        return {

        }
    },
}
</script>

<style>

</style>
